import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_vaewhar65e: FaireCollectionEntity = {
  token: "pbc_vaewhar65e",
  type: "collection",
  name: "(2T-3T Sizes) SS26 Organic Baby Styles",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4ac5c03a646e4a1eff36b39ba4ff81528704e54e61f413a5b2464b0a6bd24bd2.jpeg",
  itemCount: 21,
  description:
    "SS26 Organic baby styles that are available in 2T and 3T sizes in organic sweater knits and woven. ",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:17.909Z",
    importedBy: "entity-db-import-collections",
  },
};
